import { page, shows, type FeatureRoutes } from "@/app/feature";

const screens = page(() => import("./Screens"));
const detail = shows("hoardex", "cards");

export const routes: FeatureRoutes = {
  shell: [
    { path: "hoardex", lazy: screens, handle: shows("hoardex", "collection") },
    { path: "hoardex/kinds/:kindId", lazy: screens, handle: detail },
    { path: "hoardex/categories/:slug", lazy: screens, handle: detail },
  ],
};
